import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballFlex = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.50383 6.61631H2.55187L2.39732 7.47407H4.9629L4.74652 8.7105H2.18094L1.84093 10.6347H0.449951L1.37727 5.37988H5.72021L5.50383 6.61631ZM6.97039 9.39826H9.61325L9.39688 10.6347H5.36304L6.29036 5.37988H7.68134L6.97039 9.39826ZM15.5542 5.37988L13.4445 8.03047L14.7041 10.6347H13.1818L12.4245 8.95006L11.1803 10.6347H9.55753L11.7599 7.86046L10.5621 5.37988H12.0845L12.7877 6.94087L13.9314 5.37988H15.5542Z"
      fill="white"
    />
  </svg>
);
